import { Modal } from 'react-bootstrap';
import './style.scss';

import LightGallery from 'lightgallery/react';
import lgZoom from 'lightgallery/plugins/zoom';
import lgVideo from 'lightgallery/plugins/video';
import { ActivityStrapi } from '../../shared/interfaces';

type ActivityDetailsProps = {
  show: boolean;
  activity?: ActivityStrapi;
  onClose: () => void;
};

function ActivityDetails({ show, activity, onClose }: ActivityDetailsProps) {
  if (!activity) return null;

  return (
    <Modal className="activity-modal details" show={show} centered onHide={onClose}>
      <Modal.Header closeButton>
        <Modal.Title>{activity?.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <img src={activity?.mainImage?.url} />

        <div className="row mb-3">
          <div className="col-md-10 mx-auto">
            <p>{activity?.description} </p>
          </div>
        </div>

        <div>
          <LightGallery elementClassNames="gallery" plugins={[lgZoom, lgVideo]} mode="lg-fade">
            {activity?.images?.map((image, index) => (
              <a className="gallery-item" data-src={image?.formats?.large?.url} key={index}>
                <img className="img-responsive" src={image?.formats?.medium?.url} />
              </a>
            ))}
          </LightGallery>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default ActivityDetails;
